import React from 'react';
import { Award, Globe, Trophy, Briefcase } from 'lucide-react';
import { aboutJoseph } from '../data/mock';

const JOSEPH_IMAGE = 'https://customer-assets.emergentagent.com/job_cc168665-fdd4-4842-8c94-cfc7eba85fff/artifacts/4q2jvgb1_Sitting%20Pic.jpg';

const credentialIcons = {
  0: <Award size={16} className="text-[var(--gold-primary)]" />,
  1: <Globe size={16} className="text-[var(--gold-primary)]" />,
  2: <Trophy size={16} className="text-[var(--gold-primary)]" />,
  3: <Briefcase size={16} className="text-[var(--gold-primary)]" />,
};

const AboutSection = () => {
  return (
    <section id="about" className="section-padding bg-[var(--bg-secondary)]">
      <div className="container px-4 sm:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <img
                src={JOSEPH_IMAGE}
                alt={aboutJoseph.name}
                className="about-image w-full max-w-md mx-auto lg:mx-0"
              />
              {/* Decorative frame */}
              <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-[var(--gold-primary)] -z-10 hidden lg:block"></div>
            </div>
          </div>
          
          {/* Content */}
          <div className="order-1 lg:order-2">
            <p className="eyebrow-gold uppercase tracking-widest mb-4">
              Your Protection Strategist
            </p>
            
            <h2 className="heading-1 mb-2">{aboutJoseph.name}</h2>
            
            <p className="body-regular text-[var(--text-secondary)] mb-6">
              {aboutJoseph.title} | {aboutJoseph.subtitle}
            </p>
            
            <div className="divider mb-8"></div>
            
            {/* Credentials */}
            <div className="flex flex-wrap gap-3 mb-8">
              {aboutJoseph.credentials.map((credential, index) => (
                <div key={index} className="credential-badge">
                  {credentialIcons[index]}
                  <span>{credential}</span>
                </div>
              ))}
            </div>
            
            {/* Bio */}
            <p className="body-regular text-[var(--text-secondary)] mb-6">
              {aboutJoseph.bio}
            </p>
            
            {/* Belief Statement */}
            <p className="body-large font-medium text-[var(--text-primary)] mb-8 italic">
              "{aboutJoseph.beliefStatement}"
            </p>
            
            {/* Philosophy */}
            <div className="bg-[var(--bg-primary)] p-6 border-l-4 border-[var(--gold-primary)]">
              <p className="body-large italic text-[var(--text-primary)]">
                "{aboutJoseph.philosophy}"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
